import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { Box, Button, Typography } from "@mui/material"
import { FiltersFloat } from "../../../../../../../logbook/pages/main/components/access/components/filtersFloat"
import { DinamicForm } from "../../../../../../../../components/dinamicForm"
import { InterUserTableProps } from "./types"
import { CustomTable } from "../../../../../../../../components"
import React, { memo, useState } from "react"
import SimpleModal from "../../../../../../../../components/modal/simpleModal"


const InterUserTableComponent = ({ handleAddUser, createFilter, loadingTable, input, searchUsers, row, handleSelects, selects }: InterUserTableProps) => {

    const { t } = useTranslation()
    const styles = useStyles()
    const { cleanFilter, counter } = createFilter;
    const columnsPermissions = [
        {
            id: 'users',
            label: t('general.tags.name'),
        },
        {
            id: 'role',
            label: t('general.tags.role'),
        },
        {
            id: 'userType',
            label: t('general.tags.userType'),
        },
    ]
    const [modal, setModal] = useState<{
        open: boolean
        title: string
        description: string
        confirm: () => void
        cancel?: () => void
    }>({
        open: false,
        title: '',
        description: '',
        confirm: () => { }
    })

    const closeModal = () => { setModal(prev => ({ ...prev, open: false })) }

    const handleSearchUsers = () => {
        if (!selects?.length) {
            searchUsers()
        } else {
            setModal(prev => ({
                ...prev,
                open: true,
                title: t("general.userFilterWarningTitle"),
                description: t("general.userFilterWarningDescription"),
                cancel: closeModal,
                confirm: () => {
                    searchUsers()
                    closeModal()
                }
            }))
        }
    }


    return (
        <Box sx={styles.container}>
            <Box sx={styles.containerTitle}>
                <Typography fontWeight={'bold'}>{t('userGroup.titles.userList')}</Typography>

                <Box sx={styles.containerButtons}>
                    <Button disabled={!selects.length} variant="contained" onClick={handleAddUser}>{t('general.add')}</Button>
                    <Box sx={styles.containerFilter}>
                        <FiltersFloat title={t('general.filterBy')} cleanFilter={cleanFilter} count={counter} right={0} top={0} searchButton={{ disabled: !createFilter.query?.filter, loading: false/* !!loadings.search */, onClick: handleSearchUsers }}>
                            <DinamicForm input={Object.values(input)} onChange={createFilter.onChange} errors={createFilter.errors} values={createFilter.filterData} />
                        </FiltersFloat>
                    </Box>
                </Box>
            </Box>

            <CustomTable
                tableChecks
                defaulPagination={20}
                defaultChecks={selects}
                onClick={(e) => { handleSelects(e.checks ?? []) }}
                name="Informe General"
                dontRefresh
                column={columnsPermissions}
                row={row ?? []}
                selected={-1}
                loader={loadingTable}
            />

            <SimpleModal
                open={modal.open}
                close={() => { closeModal() }}
                removeClose={!modal?.cancel}
                title={modal.title}
                description={modal.description}
                buttonText={t('general.confirm')}
                cancelText={t('general.cancel')}
                back={modal?.cancel ?? undefined}
                next={modal.confirm ?? closeModal}
            />
        </Box>
    )
}

export const InterUserTable = memo(InterUserTableComponent)